export class UrgentDeilveryRequest {
  success = false;
  message = "";
  sttNumber = "";
  constructor(fields?: Partial<UrgentDeilveryRequest>) {
    Object.assign(this, fields);
  }
}